// extracted by mini-css-extract-plugin
export default {"content":"Project_content__yXDvN","img":"Project_img__7mJ9I","description":"Project_description__N4C2b","techs":"Project_techs__U282U","buttoms":"Project_buttoms__DOSpM"};